export function getChannelName(channelName: string) {
  if(channelName === 'icacatering')
    return 'catering'
  else if(channelName === 'icakiosk')
    return 'kiosk'
  else if(channelName === 'icapronto')
    return 'pronto'
  else if(channelName === 'icatogo')
    return 'togo'
  else if(channelName === 'other')
    return 'övrigt'
  else 
    return ''
}
export function getChannelTag(channel: string) {
  if(channel === 'catering')
    return 'icacatering'
  else if(channel === 'kiosk')
    return 'icakiosk'
  else if(channel === 'pronto')
    return 'icapronto'
  else if(channel === 'togo')
    return 'icatogo'
  else if(channel === 'övrigt')
    return 'other'
  else 
    return ''
}

export const channelDisplayNames = {
  icacatering: "ICA Catering",
  icapronto: "ICA Pronto",
  icatogo: "ICA ToGo",
  icakiosk: "ICA Kiosk",
}